fragment CustomFieldFragment on EntityAttribute {
    id
    attribute {
        displayName
        displayType
        description
    }
    customFieldStats {
        numOfForms
    }
}
